import React from 'react';
import {
  UserIcon,
  HomeIcon,
  StarIcon,
  HeartIcon,
  PhoneIcon,
  EnvelopeIcon,
  CogIcon,
  MagnifyingGlassIcon,
  CalendarIcon,
  ClockIcon,
  LockClosedIcon,
  BookmarkIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  PencilIcon,
  TrashIcon,
  CheckIcon,
  XMarkIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
  BriefcaseIcon,
  AcademicCapIcon,
  TrophyIcon,
  LightBulbIcon,
  BuildingOfficeIcon,
  ChatBubbleLeftRightIcon,
  DocumentIcon,
  GlobeAltIcon,
  ShieldCheckIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  UserGroupIcon,
  FireIcon,
  BoltIcon,
  PresentationChartLineIcon,
  RocketLaunchIcon
} from "@heroicons/react/24/outline";

export interface IconRendererProps {
  icon: string;
  className?: string;
  style?: React.CSSProperties;
}

export interface IconPickerProps {
  onChange: (icon: string) => void;
}

export interface IconPickerDialogProps {
  selected?: string | null;
  onChange: (icon: string) => void;
  buttonText?: string;
  dialogTitle?: string;
  dialogDescription?: string;
  renderTrigger?: (onClick: () => void) => React.ReactNode;
}

export interface IconRegistryItem {
  name: string;
  Component: any; // Using any to avoid complex TypeScript issues with Heroicons
}

export const iconRegistry: IconRegistryItem[] = [
  { name: 'User', Component: UserIcon },
  { name: 'Home', Component: HomeIcon },
  { name: 'Star', Component: StarIcon },
  { name: 'Heart', Component: HeartIcon },
  { name: 'Phone', Component: PhoneIcon },
  { name: 'Email', Component: EnvelopeIcon },
  { name: 'Settings', Component: CogIcon },
  { name: 'Search', Component: MagnifyingGlassIcon },
  { name: 'Calendar', Component: CalendarIcon },
  { name: 'Clock', Component: ClockIcon },
  { name: 'Lock', Component: LockClosedIcon },
  { name: 'Bookmark', Component: BookmarkIcon },
  { name: 'Download', Component: ArrowDownTrayIcon },
  { name: 'Upload', Component: ArrowUpTrayIcon },
  { name: 'Edit', Component: PencilIcon },
  { name: 'Delete', Component: TrashIcon },
  { name: 'Check', Component: CheckIcon },
  { name: 'Close', Component: XMarkIcon },
  { name: 'Arrow Right', Component: ArrowRightIcon },
  { name: 'Arrow Left', Component: ArrowLeftIcon },
  { name: 'Briefcase', Component: BriefcaseIcon },
  { name: 'Academic', Component: AcademicCapIcon },
  { name: 'Trophy', Component: TrophyIcon },
  { name: 'Lightbulb', Component: LightBulbIcon },
  { name: 'Building', Component: BuildingOfficeIcon },
  { name: 'Chat', Component: ChatBubbleLeftRightIcon },
  { name: 'Document', Component: DocumentIcon },
  { name: 'Globe', Component: GlobeAltIcon },
  { name: 'Shield', Component: ShieldCheckIcon },
  { name: 'Dollar', Component: CurrencyDollarIcon },
  { name: 'Chart', Component: ChartBarIcon },
  { name: 'Users', Component: UserGroupIcon },
  { name: 'Fire', Component: FireIcon },
  { name: 'Bolt', Component: BoltIcon },
  { name: 'Presentation', Component: PresentationChartLineIcon },
  { name: 'Rocket', Component: RocketLaunchIcon }
];

export const iconPickerConfig = {
  dialogTitle: "Select an Icon",
  dialogDescription: "Choose the best suited icon",
  cancelButtonText: "Cancel",
  searchPlaceholder: "Search icons...",
  noIconsFoundText: "No icons found...",
  clearSearchText: "Clear search",
  selectButtonText: "Select",
  updateButtonText: "Update",
  changeButtonText: "Change",
  selectIconLabel: "Select Icon:",
  defaultIconName: "Star",
  availableIcons: [
    "User", "Home", "Star", "Heart", "Phone", "Email", 
    "Settings", "Search", "Calendar", "Clock", "Lock", 
    "Bookmark", "Download", "Upload", "Edit", "Delete", 
    "Check", "Close", "Arrow Right", "Arrow Left", 
    "Briefcase", "Academic", "Trophy", "Lightbulb",
    "Building", "Chat", "Document", "Globe", "Shield",
    "Dollar", "Chart", "Users", "Fire", "Bolt", 
    "Presentation", "Rocket"
  ]
};